export default {
	languages: [
		['en', 'English'],
		['zh', '中文']
	]
}